import moment from "moment-timezone";

const getInclusivePublicationMinute = (time: number) => {
	const value = moment(time);
	const minute = value.clone().startOf("minute");
	return minute.isBefore(value) ? minute.add(1, "minute") : minute;
};

const getExclusivePublicationMinute = (time: number) =>
	moment(time).startOf("minute").add(1, "minute");

export const getSectionSpecEarliestPublicationMinute = (
	previousEffectiveTime: number | null,
	latestActiveInspectionTime: number | null,
) => {
	const previousEffectiveMinute =
		previousEffectiveTime === null
			? null
			: getInclusivePublicationMinute(previousEffectiveTime);
	const latestActiveInspectionMinute =
		latestActiveInspectionTime === null
			? null
			: getExclusivePublicationMinute(latestActiveInspectionTime);

	if (previousEffectiveMinute === null)
		return latestActiveInspectionMinute ?? undefined;
	if (latestActiveInspectionMinute === null) return previousEffectiveMinute;

	return previousEffectiveMinute.isAfter(latestActiveInspectionMinute)
		? previousEffectiveMinute
		: latestActiveInspectionMinute;
};
